<template>
	<div>
		<SelectTableDataInput v-model="tableSourceLocal" inputFieldHint="Choose table source" />
		<SubFolderIndicatorLine />
		<v-autocomplete
			dense
			outlined
			hide-details
			:items="columnOptions"
			v-model="tableTextColumn"
			placeholder="Select a column"
			:disabled="!tableSourceLocal"
			:class="{ disabled: !tableSourceLocal }"
			class="auto-complete-container px-3 mt-6"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import InputComponentMixinBase from './mixins/InputComponentMixinBase';
import { getPreviousStepDataForNodeByUUID } from '@/store/modules/nodes/getters';
import SelectTableDataInput from '@/components/DataInput/DataInputFields/SelectTableDataInput';
import SubFolderIndicatorLine from '@/components/BlockEditor/TableActionEditor/SubFolderIndicatorLine';
import TableActionEditorService from '@/components/BlockEditor/TableActionEditor/table-action-edtior-service';
import { replaceInsertDataStringDictionary } from '@/store/modules/selectedWorkflow/getters';
import { configurationsMappingBlocksUUIDs } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
export default {
	name: 'MultiSelectColumnSelection',
	mixins: [InputComponentMixinBase],
	components: {
		SelectTableDataInput,
		SubFolderIndicatorLine,
	},
	props: {
		tableSource: { type: String },
		selectedColumn: { type: String },
	},
	computed: {
		...mapGetters([
			getPreviousStepDataForNodeByUUID.fullPath,
			replaceInsertDataStringDictionary.fullPath,
			configurationsMappingBlocksUUIDs.fullPath,
		]),
		tableSourceLocal: {
			get() {
				return this.tableSource;
			},
			set(value) {
				this.updateParamsMap(value);
			},
		},
		tableTextColumn: {
			get() {
				return this.selectedColumn;
			},
			set(value) {
				this.updateParamsMap(this.tableSourceLocal, value);
			},
		},
		columnOptions() {
			if (!this.tableSource) {
				return [];
			}
			const options = TableActionEditorService.columnDefsFromPreviousSteps(this.tableSourceRows, true);
			return options.map((o) => o.field);
		},
		tableSourceRows() {
			return (
				TableActionEditorService.rowsFromPreviousSteps(
					this.tableSource,
					this[getPreviousStepDataForNodeByUUID.fullPath],
					this[replaceInsertDataStringDictionary.fullPath],
					this[configurationsMappingBlocksUUIDs.fullPath]
				) || []
			);
		},
	},
	methods: {
		updateParamsMap(tableSource, columnName) {
			this.$emit('update-params-map', { table_source: tableSource, column_name: columnName });
		},
	},
	mounted() {
		this.$emit('close');
	},
};
</script>
<style lang="scss" scoped>
.auto-complete-container {
	&::v-deep {
		&.v-text-field--outlined fieldset {
			border-color: var(--forth-border-color);
		}
		&.v-text-field.v-input--is-focused fieldset {
			border: 1px solid var(--primary-border-color) !important;
		}
		&.v-input {
			font-size: 14px;
			&.disabled {
				opacity: 0.5;
			}
		}
	}
}
</style>
